import { Box, Grid, Typography } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {
  playerTeamLogo,
  teamCardElement,
  teamCardRoundElement,
} from "../../../Assets";
import {
  formatToIndianCurrencyWords2,
  teamGradients,
} from "../../../Utils/helperFunctions";

const AdminTeamSection: React.FC<any> = ({
  teamDetails,
  setStep,
  setSelectedTeamIndex,
}) => {
  return (
    <>
      <Box height={"fit-content"}>
        <a
          href="https://t20mumbai.com/"
          style={{
            textDecoration: "none",
            color: "#fff",
            fontSize: "18px",
            display: "flex",
            gap: 1,
            padding: "0 0 20px",
            marginBottom: "20px",
          }}
        >
          <ArrowBackOutlinedIcon />
          Go Back
        </a>
        <Grid
          container
          sx={{ width: "80%" }}
          columnSpacing={{ xs: "8px", md: "16px", xl: "20px" }}
          rowSpacing={{ xs: "52px", md: "50px", xl: "50px" }}
        >
          {teamDetails?.map((item: any, i: number) => (
            <Grid item key={i} xs={12} sm={6} lg={4} xl={3}>
              <AdminTeamCard
                team={item}
                setStep={setStep}
                setSelectedTeamIndex={setSelectedTeamIndex}
                index={i}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

const AdminTeamCard: React.FC<any> = ({
  team,
  setStep,
  index,
  setSelectedTeamIndex,
}) => {
  const players = team?.Player_Registrations__r?.records || [];
  const gradient = teamGradients[team?.Name] || { from: "#1e1e1e", to: "#444" }; // fallback gradient
  const getCategoryCount = (level: string) =>
    players.filter((p: any) => p.Recent_Competitive_Level__c === level).length;

  const totalPlayers = players.length;
  const remainingFundFormatted = formatToIndianCurrencyWords2(
    team?.Fund_Remaining__c
  );

  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: "12px",
        // overflow: "hidden",
        p: "16px",
        display: "flex",
        justifyContent: "center",
        // alignItems: "center",
        background: `linear-gradient(to bottom, ${gradient.from}, ${gradient.to})`,
        height: "fit-content",
        minHeight: "200px",
      }}
      onClick={() => {
        setStep(2);
        setSelectedTeamIndex(index);
      }}
    >
      <Box
        sx={{
          position: "absolute",
          zIndex: 3,
          textAlign: "center",
          top: "-40px",
          backgroundColor: "white",
          padding: "15px",
          width: "65px",
          height: "65px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: "100px",
        }}
      >
        <img
          src={
            team?.Name == "Aakash Tigers MWS"
              ? "https://turbostart.blob.core.windows.net/turbostart/48447191083078844-aakashTigers.png"
              : team?.Name == "MSC Maratha Royals"
              ? "https://mcadirectory.blob.core.windows.net/dev/4441894866960012-shivajiParkLions.png"
              : team?.Name == "Triumph Knights Mumbai North East"
              ? "https://mcadirectory.blob.core.windows.net/dev/007792959990218895-triumphKnights.png"
              : team?.Logo_URL__c || playerTeamLogo
          }
          alt="Team Logo"
          width={100}
          height={100}
          style={{
            height: "auto", // roughly h-28
            width: "60px",
            margin: "0 auto",
          }}
        />
      </Box>
      <Box mt={"40px"} sx={{ textAlign: "center", width: "100%" }}>
        <Typography
          variant="h1"
          sx={{ fontSize: "16px", fontWeight: 400, mb: "4px" }}
          color="white"
        >
          Fund remaining
        </Typography>
        <Typography
          variant="h1"
          sx={{ fontSize: "28px", fontWeight: 600 }}
          color="white"
        >
          {remainingFundFormatted}
        </Typography>
        <Grid container spacing={"6px"} mt={"0"}>
          {[
            {
              label: "Icon",
              count: getCategoryCount("Indian senior team"),
              minPlayerCount: 1,
            },
            {
              label: "Senior",
              count: getCategoryCount(
                "First class, list A, BCCI Senior Men T20"
              ),
              minPlayerCount: 4,
            },
            {
              label: "Emerging",
              count: getCategoryCount(
                "Mumbai age group team (under 23 or under 19)"
              ),
              minPlayerCount: 5,
            },
            {
              label: "Development",
              count: getCategoryCount("Local club team"),
              minPlayerCount: 5,
            },
          ].map((item, index) => (
            <Grid item xs={6} key={index}>
              <Box
                sx={{
                  bgcolor: "#FFFFFF36",
                  padding: "2px 0",
                  width: "100%",
                  color: "#fff",
                  borderRadius: "0.3vw",
                  border: "0.5px solid #EAEAEA",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontSize: "14px", fontWeight: 700, mb: "4px" }}
                  color="white"
                >
                  {item.count}/{item.minPlayerCount}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "16px",
                    fontWeight: 600,
                    padding: "4px 0",
                    background:
                      "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.30) 50%, rgba(255, 255, 255, 0.00) 100%)",
                  }}
                  color="white"
                >
                  {item.label}
                </Typography>
              </Box>
            </Grid>
          ))}
          <Grid item xs={12}>
            <Box
              sx={{
                bgcolor: "#FFFFFF36",
                padding: "2px 0",
                width: "100%",
                color: "#fff",
                borderRadius: "8px",
                border: "0.5px solid #EAEAEA",
              }}
            >
              <Typography
                variant="h4"
                sx={{ fontSize: "16px", fontWeight: 700, mb: "6px" }}
                color="white"
              >
                {totalPlayers}/18
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  padding: "2px 0",
                  background:
                    "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.30) 50%, rgba(255, 255, 255, 0.00) 100%)",
                }}
                color="white"
              >
                {/* {item.label} */}
                Total Players
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
  // const players = team?.Player_Registrations__r?.records || [];
  // const gradient = teamGradients[team?.Name] || { from: "#1e1e1e", to: "#444" }; // fallback gradient

  // return (
  //   <Box
  //     sx={{
  //       position: "relative",
  //       borderRadius: ".3vw",
  //       // overflow: "hidden",
  //       p: "0.5vw",
  //       display: "flex",
  //       justifyContent: "center",
  //       // alignItems: "center",
  //       background: `linear-gradient(to bottom, ${gradient.from}, ${gradient.to})`,
  //       height: "fit-content",
  //       minHeight: "200px",
  //       flexDirection: "column",
  //       // justifyItems: "center",
  //       alignItems: "center",
  //     }}
  //     onClick={() => {
  //       setStep(2);
  //       setSelectedTeamIndex(index);
  //     }}
  //   >
  //     <Box
  //       sx={{
  //         position: "absolute",
  //         top: 0,
  //         left: 0,
  //         width: "100%",
  //         height: "100%",
  //         borderRadius: "1rem", // matches Tailwind's rounded-xl
  //         opacity: 0.6,
  //         zIndex: 1,
  //       }}
  //       component="img"
  //       src={teamCardRoundElement}
  //       alt="Logo"
  //     />

  //     <Box
  //       sx={{
  //         position: "absolute",
  //         top: 0,
  //         left: 0,
  //         width: "100%",
  //         height: "100%",
  //         borderRadius: "1rem",
  //         zIndex: 2,
  //       }}
  //       component="img"
  //       src={teamCardElement}
  //       alt="Logo"
  //     />

  //     <Box
  //       sx={{
  //         textAlign: "center",
  //         width: "150px",
  //         height: "150px",
  //         display: "flex",
  //         justifyContent: "center",
  //         flexDirection: "column",
  //         alignItems: "center",
  //         borderRadius: "5vw",
  //       }}
  //     >
  //       <img
  //         src={
  //           team?.Name == "Aakash Tigers MWS"
  //             ? "https://turbostart.blob.core.windows.net/turbostart/48447191083078844-aakashTigers.png"
  //             : team?.Name == "Aakash Tigers MWS"
  //             ? "https://turbostart.blob.core.windows.net/turbostart/48447191083078844-aakashTigers.png"
  //             : team?.Name == "Triumph Knights MNE"
  //             ? "https://mcadirectory.blob.core.windows.net/dev/007792959990218895-triumphKnights.png"
  //             : team?.Logo_URL__c || playerTeamLogo
  //         }
  //         alt="Team Logo"
  //         width={100}
  //         height={100}
  //         style={{
  //           position: "relative",
  //           zIndex: "10",
  //           height: "100%",
  //           width: "100%",
  //           objectFit: "contain",
  //         }}
  //       />
  //     </Box>
  //     <Box mt={4} sx={{ textAlign: "center", width: "100%" }}>
  //       <Typography
  //         variant="h6"
  //         sx={{
  //           fontWeight: 400,
  //           mb: ".2VW",
  //           padding: "12px",
  //         }}
  //         color="white"
  //       >
  //         {team?.Name}
  //       </Typography>
  //     </Box>
  //   </Box>
  // );
};

export default AdminTeamSection;
